"use strict";

import angular from "angular";

const name = "natureOfAccount";
const factory = function natureOfAccountFilter() {
    return function (name, nature, index, source) {
        if (typeof index === "number" && index === 0) return name;
        const exceptions = ["(+)", "(=)", "(±)", "(%)"];
        if (exceptions.some((exception) => name.includes(exception)))
            return name;
        const sources = ["fin", "financial", "f"];
        const multiplierNegative = "(-)";
        const multiplierPositive = sources.includes(source) ? "(+) " : "";
        let serieName = "";
        if (nature === "negative") serieName = `${multiplierNegative} ${name}`;
        else serieName = `${multiplierPositive} ${name}`;
        return serieName;
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
